import type { MultiBrandConfig } from './types';

// Website 06 — Photo Commerce / Travel Connected storefront. Mainstream,
// trust-first, realistic travel ECOMMERCE for broad paid + organic traffic:
// real travel photography, bold black type, bright blue CTAs, social-proof
// density, commercial polish (photo-day / photo-night palettes). The easiest
// brand for average travelers to trust quickly. Name/domain PROVISIONAL.
//
// DOMAIN NOTE: points at esimsupra.com for now because every storefront shares
// ONE backend (functions/ + billing worker + D1). Before this is deployed as
// its own indexed property it MUST get its own canonical domain + contact email
// to avoid cross-brand duplicate-content / canonical conflicts. Build-selectable
// for preview only (BRAND_ID=photo-commerce-travel-connected).
//
// CLAIM-SAFETY: the mockups are saturated with unverifiable proof (Trustpilot
// scores, review counts, "millions of users"). NONE are reproduced. Social
// proof is rebuilt with neutral, supportable copy only and no AggregateRating.
export const photoCommerce: MultiBrandConfig = {
  id: 'photo-commerce-travel-connected',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'Mainstream, trust-first travel eSIM ecommerce for everyday holiday travelers, families and high-intent shoppers — real travel photography, visible pricing, commercial polish and supportable social proof, built to be the easiest brand to trust quickly.',
  theme: {
    mode: 'light', // clean white commercial UI, light-first
    defaultDark: 'photo-night',
    defaultLight: 'photo-day',
  },
  checkoutEnabled: true,
  // Content-creator brand: trust/quality-led framing. Presentation only.
  pricingDisplayMode: 'photo-trust',
  legacy: {
    brand: {
      name: 'Travel Connected',
      displayName: 'Travel Connected',
      tagline: 'Travel connected in minutes',
      description:
        'Buy a travel eSIM before you fly. Choose your destination, pay securely, and get your eSIM by email instantly — no physical SIM, no contract, no roaming surprises, with friendly support if you need it.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'Travel Connected Logo',
    },
    contact: {
      // TODO(brand-email): planned dedicated inbox `hello@esimworthy.com` (TBD) before indexed launch (R14). Shared inbox for now.
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} Travel Connected. All rights reserved.`,
    },
    features: {
      count180Countries: '180+ Countries',
      uptimePerformance: 'Fast 4G/5G',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for esimworthy.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'PHOTOCO',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'esimworthy.com',
      url: 'https://esimworthy.com',
      organizationLegalName: 'TBD — register legal entity for Travel Connected',
    },
    llms: {
      tagline: 'Buy a travel eSIM before you fly',
      audience: 'Mainstream, trust-first consumers buying their first travel eSIM through a clear retail flow.',
    },
  },
};

export default photoCommerce;
